
import { createContext } from 'react';

const permissionContext = createContext();

export default permissionContext;